package com.appsyde.shared.presentation.screen.component.ticket

import androidx.compose.runtime.Composable
import com.appsyde.shared.presentation.style.style.AppStylesTickets
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun TicketsSection(
    title: String,
    subtitle: String,
    rows: List<TicketRowUi>,
    selectedTicketId: String? = null,
    onTicketSelected: ((String) -> Unit)? = null,
    titleOverrideForTicket: ((ticketId: String) -> String?)? = null,
    expanded: Boolean = true,
    onToggleExpand: (() -> Unit)? = null
) {
    val titleDotClass = when {
        title.contains("trait", ignoreCase = true) -> AppStylesTickets.sectionTitleDotOpen
        title.contains("attente", ignoreCase = true) -> AppStylesTickets.sectionTitleDotWaiting
        else -> AppStylesTickets.sectionTitleDotClosed
    }

    Div(attrs = {
        if (onToggleExpand != null) {
            classes(AppStylesTickets.sectionHeader, AppStylesTickets.sectionHeaderClickable)
        } else {
            classes(AppStylesTickets.sectionHeader)
        }
        if (onToggleExpand != null) {
            onClick { onToggleExpand() }
            attr("role", "button")
            attr("aria-label", if (expanded) "Replier la section" else "Déplier la section")
        }
    }) {
        Div({ classes(AppStylesTickets.sectionTitleCol) }) {
            Div({ classes(AppStylesTickets.sectionTitleRow) }) {
                Span({ classes(AppStylesTickets.sectionTitleDot, titleDotClass) })
                Div({ classes(AppStylesTickets.sectionTitle) }) { Text(title) }
            }
            Div({ classes(AppStylesTickets.sectionSub) }) { Text(subtitle) }
        }
        Div({ classes(AppStylesTickets.sectionRightMeta) }) {
            Div({ classes(AppStylesTickets.sectionCount) }) { Text("${rows.size}") }
            if (onToggleExpand != null) {
                Span({ classes(AppStylesTickets.sectionChevron) }) { Text(if (expanded) "▾" else "▴") }
            }
        }
    }

    if (expanded) {
        Div({ classes(AppStylesTickets.rowsWrap) }) {
            rows.forEach { row ->
                TicketRow(
                    row = row,
                    isSelected = row.ticketId == selectedTicketId,
                    onClick = { onTicketSelected?.invoke(row.ticketId) ?: Unit },
                    titleOverride = titleOverrideForTicket?.invoke(row.ticketId)
                )
            }
        }
    }
}
